import { ApplyLink, Arrow } from './ui'
import { useViewportVideo } from './useViewportVideo'
import VideoSoundControl from './VideoSoundControl'
import VideoPoster from './VideoPoster'
import './benefits-video.css'

const highlights = [
  { title: 'เครือข่ายและมิตรภาพ', copy: 'พบผู้หญิงที่พร้อมเรียนรู้และเติบโตไปด้วยกัน' },
  { title: 'เปิดโลกของ Wellness', copy: 'รู้จักแบรนด์และผู้สนับสนุน ผ่านกิจกรรมและบูธในงาน' },
  { title: 'ประสบการณ์ที่ต่อยอดได้', copy: 'เปิดมุมมองใหม่และโอกาสในการสร้างความสัมพันธ์' },
]

export default function BenefitsVideo() {
  const { error, videoProps, previewProps, controlsProps } = useViewportVideo('/images/competition-benefits-poster.jpg')

  return <section className="benefits-video section-pad" id="competition-benefits" aria-labelledby="benefits-video-title">
    <div className="benefits-video-inner">
      <header className="benefits-video-heading">
        <p className="benefits-video-eyebrow"><span aria-hidden="true" />WHAT YOU’LL GAIN</p>
        <p className="benefits-video-kicker">สิ่งที่จะได้รับจากการประกวด</p>
        <h2 id="benefits-video-title">มากกว่าการประกวด<br /><em>คือโอกาสใหม่ของคุณ</em></h2>
      </header>

      <figure className="benefits-film" aria-labelledby="benefits-film-title">
        <div className="benefits-film-frame">
          <video {...videoProps} width="720" height="1280" aria-label="วิดีโอสิ่งที่จะได้รับจากการประกวด EMPRESS OF WELLNESS 2026">
            <source src="/videos/competition-benefits.mp4" type="video/mp4" />
            เบราว์เซอร์นี้ไม่รองรับวิดีโอ <a href="/videos/competition-benefits.mp4">เปิดคลิปสิ่งที่จะได้รับจากการประกวด</a>
          </video>
          <VideoPoster {...previewProps} />
        </div>
        <VideoSoundControl {...controlsProps} />
        <figcaption><div><span>EMPRESS OF WELLNESS 2026</span><strong id="benefits-film-title">สิ่งที่จะได้รับจากเวทีนี้ <small>00:37</small></strong></div><a href="/videos/competition-benefits.mp4" target="_blank" rel="noopener noreferrer" aria-label="เปิดคลิปสิ่งที่จะได้รับจากการประกวดในแท็บใหม่"><Arrow /></a></figcaption>
        {error && <p className="benefits-film-error" role="alert">ยังไม่สามารถเล่นวิดีโอได้ ลองกดเล่นอีกครั้ง หรือ <a href="/videos/competition-benefits.mp4" target="_blank" rel="noopener noreferrer">เปิดวิดีโอโดยตรง</a></p>}
      </figure>

      <div className="benefits-video-copy">
        <p>ชมภาพรวมของประสบการณ์ การพบผู้คนใหม่<br />และการเชื่อมต่อกับแบรนด์ Wellness<br />บนเวที EMPRESS OF WELLNESS</p>
        <ol className="benefits-video-highlights">{highlights.map((highlight, index) => <li key={highlight.title}><span className="benefits-highlight-number" aria-hidden="true">0{index + 1}</span><div><h3>{highlight.title}</h3><p>{highlight.copy}</p></div></li>)}</ol>
        <div className="benefits-video-actions"><ApplyLink location="competition-benefits-video" light /><a className="text-link" href="#benefits">ดูสิ่งที่จะได้รับทั้งหมด <Arrow /></a></div>
      </div>
    </div>
  </section>
}
